var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"take-max-height"},[_c('Error',{attrs:{"code":404,"message":"Page Not Found"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }